module.exports = __webpack_public_path__ + "img/new-house-2-min.8f9bdfd8.png";